import { useState } from 'react';
import ReactPlayer from 'react-player';
import Button from 'src/modules/shared/components/atoms/buttons/button';
import { Text } from 'src/modules/shared/components/atoms/text';
import { useFeatureFlagActive } from 'hooks/settings/feature-flags';
import { useHasRoles } from 'src/modules/shared/hooks/auth';
import { SettingName } from 'src/api/generated';
import type { TimelineRecordingPlayerProps } from '../../../types/timeline/call-recording.types';

/** Inline recording player; mounting never downloads or starts the audio. */
export function TimelineRecordingPlayer({
  url,
  onRetry,
  playing,
  onPlay,
}: TimelineRecordingPlayerProps) {
  const [failed, setFailed] = useState(false);
  const [started, setStarted] = useState(false);
  const { hasRole: isAdmin } = useHasRoles('Admin');
  const allowDownload = useFeatureFlagActive(
    SettingName.FEATURE_FLAG_ADMIN_DOWNLOAD_RECORDINGS
  );
  if (failed) {
    return (
      <div className="flex flex-wrap items-center gap-2">
        <Text size="tiny" color="secondary">
          No se pudo reproducir el audio.
        </Text>
        <Button
          size="xs"
          appearance="ghost"
          variant="neutral"
          onClick={async () => {
            await onRetry();
            setFailed(false);
          }}
        >
          Reintentar audio
        </Button>
      </div>
    );
  }
  return (
    <ReactPlayer
      url={url}
      controls
      playing={started && playing}
      onPlay={() => {
        setStarted(true);
        onPlay();
      }}
      width="100%"
      height={40}
      onError={() => setFailed(true)}
      config={{
        file: {
          forceAudio: true,
          attributes: {
            preload: 'none',
            controlsList: isAdmin && allowDownload ? '' : 'nodownload',
          },
          forceHLS: false,
          hlsOptions: {},
        },
      }}
    />
  );
}
